import type { FC } from 'react'
import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Navigation from '@segment/templates/Navigation'
import Footer from '@segment/templates/Footer'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import TalkToAnExpert from './components/TalkToAnExpert'
import PricingTable from './components/PricingTable'

const SupportPlanComparison: FC = () => {
  const theme = useTheme()
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Support | Twilio Segment"
        pageDescription="Learn more about which Twilio Segment support plan is right for you."
        themeColor={theme.palette.twilio.gray[10]}
      >
        <Navigation />
        <Hero />
        <Main>
          <PricingTable />
          <TalkToAnExpert />
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

export default SupportPlanComparison

const Main = styled.main`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`
